/* eslint-disable no-shadow */
import { call, takeEvery } from "redux-saga/effects";
import noop from "lodash.noop";

import {
    CURRENT_ORGANISATION_REQUESTED,
    defaultScopeId,
    failCurrentOrganisation,
    succeedCurrentOrganisation,
} from "./organisation.duck";

import { loadCurrentOrganisation } from "./organisation.api";

import { injectBoundGQLClient } from "Utils/injectBoundGQLClient";

import {
    getId,
    injectApiWithContextFactory,
    injectBoundActionCreatorsFactory,
} from "Utils/sagaUtils";

export const withBoundActions = injectBoundActionCreatorsFactory(
    {
        succeedCurrentOrganisation,
        failCurrentOrganisation,
    },
    getId,
    defaultScopeId
);

export const withApiContext = injectApiWithContextFactory(
    {
        loadCurrentOrganisation,
    },
    injectBoundGQLClient
);

export function* loadCurrentOrganisationSaga({
    actions: { succeedCurrentOrganisation, failCurrentOrganisation },
    api: { loadCurrentOrganisation },
    resolve = noop,
    reject = noop,
}) {
    try {
        const result = yield loadCurrentOrganisation();
        yield succeedCurrentOrganisation(result);
        yield call(resolve);
    } catch (e) {
        yield failCurrentOrganisation(e);
        yield call(reject, e);
    }
}

export default () =>
    function* rootSaga() {
        yield takeEvery(
            CURRENT_ORGANISATION_REQUESTED,
            withBoundActions(withApiContext(loadCurrentOrganisationSaga))
        );
    };
